module.exports = __webpack_public_path__ + "static/media/Mushroom.f11e3685.jpg";